import { Responsive, TooltipMobile } from '@cian/ui-kit';

import { type FC, type ReactElement } from 'react';

type TAwardCardTooltipProps = {
  text: string;
  children: ReactElement;
};

export const AwardCardTooltip: FC<TAwardCardTooltipProps> = ({ children, text }) => {
  return (
    <>
      <Responsive desktop>{children}</Responsive>
      <Responsive phone tablet>
        <TooltipMobile title={text}>{children}</TooltipMobile>
      </Responsive>
    </>
  );
};
